import { constants } from '../../config';
import { get, getHeaders } from './services.common';

export const fetchStoreInfoService = async (params: { storeSlug: string }) => {
  const url = constants.API + `/store/YuStore/store-info`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
    },
  });
  return response;
};

export const fetchStoreProductListService = async (params: { storeSlug: string }) => {
  const url = constants.API + `/store/YuStore/all-products`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
    },
  });
  return response;
};

export const fetchStoreProductInfoService = async (params: { storeSlug: string; productId: string }) => {
  const url = constants.API + `/store/YuStore/product`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
      storeProductId: params.productId,
    },
  });
  return response;
};

export const fetchStoreProductCategoriesService = async (params: { storeSlug: string }) => {
  const url = constants.API + `/store/YuStore/product-categories-for-store`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
    },
  });
  return response;
};

export const fetchStoreProductsByCategoryService = async (params: { storeSlug: string; categoryId: string }) => {
  const url = constants.API + `/store/YuStore/by-category`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
      categoryId: params.categoryId,
    },
  });
  return response;
};

export const fetchStoreProductsBySearchService = async (params: {
  storeSlug: string;
  searchText: string;
  categoryId?: string;
}) => {
  const url = constants.API + `/store/YuStore/search`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
      searchText: params.searchText,
      storeCategoryId: params.categoryId ?? '',
    },
  });
  return response;
};

export const fetchPurchaseOrderByIdService = async (params: {
  storeSlug: string;
  purchaseOrderId: string;
  shopperAccountId: string;
}) => {
  const url = constants.API + `/store/PurchaseOrder/by-id`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
      purchaseOrderId: params.purchaseOrderId,
      shopperAccountId: params.shopperAccountId,
    },
  });
  return response;
};

export const fetchPurchaseOrdersService = async (params: {
  storeSlug: string;
  shopperAccountId: string;
}) => {
  const url = constants.API + `/store/PurchaseOrder/list`;
  const headers = { ...getHeaders() };
  const response = await get({
    url,
    headers,
    params: {
      merchantStoreSlugId: params.storeSlug,
      shopperAccountId: params.shopperAccountId,
    },
  });
  return response;
};
